import './index.scss';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { createRoot } from 'react-dom/client';

import App from './App';

// TODO: Readd Sentry when the new organization is set up
// void (async () => {
//   try {
//     Sentry.init({
//       dsn: String(import.meta.env.VITE_APP_SENTRY_DSN_URL),
//       environment: String(import.meta.env.VITE_APP_SENTRY_ENVIRONMENT),
//       integrations: [
//         new Integrations.BrowserTracing({
//           // only send sentry-trace header to https://checkout.derstandard.builders|at
//           tracingOrigins: [window.location.origin]
//         })
//       ],
//       sampleRate: parseFloat(import.meta.env.VITE_APP_SENTRY_SAMPLE_RATE),

//       // Set tracesSampleRate to 1.0 to capture 100%
//       // of transactions for performance monitoring.
//       // We recommend adjusting this value in production
//       tracesSampleRate: parseFloat(String(import.meta.env.VITE_APP_SENTRY_TRACE_SAMPLE_RATE))
//     });

//     Sentry.setTag('environment', import.meta.env.VITE_APP_SENTRY_ENVIRONMENT);
//   } catch (error) {
//     // Log to console if Sentry fails to initialize
//     // eslint-disable-next-line no-console
//     console.error('Failed to initialize Sentry:', error);
//   }

//   main();
// })().catch((error) => {
//   // Catch any IIFE errors and still start the app
//   // eslint-disable-next-line no-console
//   console.error('Unexpected error during initialization:', error);
//   main();
// });

/**
 * That function will be called after loading polyfills
 */
function main() {
  const container = document.getElementById('root');
  if (!container) throw new Error('Root element not found');
  const root = createRoot(container);

  root.render(<App />);
}

main();
